import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { getLabel } from '../../utils';
import HeaderNewsHolder from './HeaderNewsStyles';


const HeaderNews = ({current_news}) => {
	let curIndex = 0;
	const [selected, setSelected] = useState(null);

	useEffect(() => {
		if(current_news.length > 0) {
			const showNextInter = setInterval(()=> {
				showNext();
			},5000);
			setSelected(current_news[curIndex]);
			return ()=> clearInterval(showNextInter);
		} else if (selected) {
			setSelected(null);
		}
	},[current_news]);

	const showNext = () => {
		if(current_news) {
			let newIndex = curIndex < current_news.length - 1 ? curIndex + 1 : 0;

			if(curIndex !== newIndex) { 
				curIndex = newIndex;
				setSelected(current_news[curIndex]);
			}
		}
	}

	const renderNew = ()=> {
		if(!selected)
			return null;
		return (
			<>
				{ selected.isLivestream_b === "true" && (
					<a href={selected.url} className="video-live-link">
						<div className="video-live-label">
							<img src="/static-assets/theme/svg/target.svg" alt="target-icon" />
							<span>{getLabel("LIVE")}</span>
						</div>
					</a>
				) }
				<ReactCSSTransitionGroup 
					transitionName={{
						enter: 'enter',
						leave: 'leave',
						appear: 'appear',
					}}
					transitionEnterTimeout={ 500 } 
					transitionLeaveTimeout={ 300 }
					
				>
					<a
						href={selected.url}
						target={selected.open_new_tab_b === 'true' ? '_blank' : '_self'}
					>
						{selected.news_text}
					</a>
				</ReactCSSTransitionGroup>
			</>
		)
	}

	return (
		<HeaderNewsHolder>
			<div className="break-news">
				{renderNew()}
			</div>
		</HeaderNewsHolder>
	)
}

const mapStateToProps = (store) => ({
	current_news: store.breakingNews.news
});

export default connect(mapStateToProps,null)(HeaderNews);